import {
  MyUserGetViewModel,
  TourPrebookUpdatePersonRequestViewModel,
} from '@api/v3';
import clean from '@utils/cleanObject';

export const TOUR_FIELDS_TO_COMPARE = [
  'id',
  'firstName',
  'lastName',
  'birthDate',
  'gender',
  'phone',
  'trin',
];

export function compareSavedUsersToTourGuests(
  arr: MyUserGetViewModel[],
  obj: MyUserGetViewModel,
  fields: string[]
): boolean {
  // Filter fields to include only those that exist in the obj
  fields = fields.filter((field) => {
    const lowerItemKey = field.toLowerCase();
    return Object.keys(obj).some((key) => key.toLowerCase() === lowerItemKey);
  });

  // Original logic remains the same
  return arr.some((item) =>
    fields.every((field) => {
      const lowerItemKey = field.toLowerCase();
      const lowerObjKey = Object.keys(obj).find(
        (key) => key.toLowerCase() === lowerItemKey
      );
      return (
        lowerObjKey &&
        obj[lowerObjKey]?.toLowerCase() === item[field]?.toLowerCase()
      );
    })
  );
}

export const formatTourItemBeforeComparison = (
  item: TourPrebookUpdatePersonRequestViewModel
) => {
  return clean({
    id: item?.id ?? '',
    firstName: item?.firstname ?? '',
    lastName: item?.lastname ?? '',
    gender: item?.gender ?? '',
    trin: item?.identityNumber ?? '',
    phone: item?.phoneNumber ?? '',
    birthDate: item?.birthdate ?? '',
  });
};
